import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import LogisticStackFeature from "./LogisticStackFeature";
import LogisticStackBenefits from "./LogisticStackBenefits";

const data1 = [
  "    Transport Management: It enables users to request transportation or storage services from logistic providers, facilitating efficient handling of goods and materials.",
  "Storage Management: It enables users to request storage services from storage providers, facilitating efficient storage of goods and materials.",
  "Booking Management: In the booking management process, a booking is first created by capturing essential details. Next, it is assigned a unique trip ID to link it to a specific route. Finally, a driver is designated to the booking to ensure efficient execution of the transportation.",
];
const data2 = [
  "Beckn API: TradeHub backend network based api implemented to achieve decentralized and P2P architecture. This is done for wider interoperability among the agrifood ecosysten players.",
  "IAM: IAM  validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
  "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
];
// LogisticStack Component 

export default function LogisticStack() {
  return (
    <>
      {/* Section: Header Banner */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["Logistic Stack"]}
        bannerbodycopy="Transport Management | Storage Management | Booking Management"
      />

      {/* Section: Overview */}
      <SolutionEcosystem title="Overview" type="LPS" />

      {/* Section: Feature Highlights */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Section: Additional Features */}
      <LogisticStackFeature />

      {/* Section: Benefits */}
      <LogisticStackBenefits />

      {/* Section: Call to Action */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software?"
        />
      </Container>
    </>
  );
}

